import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cz_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Always expose a readable string detail so toasts never receive objects/arrays
// Server may take a few seconds to wake up: retry safe requests on network failure
const RETRY_DELAYS = [1500, 3000, 5000, 8000, 12000];
const isRetryable = (cfg) =>
  cfg && (cfg.method === "get" || /\/auth\//.test(cfg.url || ""));

api.interceptors.response.use((r) => r, async (error) => {
  const cfg = error?.config;
  if (!error.response && isRetryable(cfg)) {
    cfg._retry = (cfg._retry || 0) + 1;
    if (cfg._retry <= RETRY_DELAYS.length) {
      await new Promise((r) => setTimeout(r, RETRY_DELAYS[cfg._retry - 1]));
      return api(cfg);
    }
  }
  const data = error?.response?.data;
  if (data && typeof data === "object" && data.detail !== undefined && typeof data.detail !== "string") {
    data.detail = formatApiError(data.detail);
  }
  if (!error.response) {
    error.response = { status: 0, data: { detail: "Sem conexão com o servidor. Verifique sua internet e tente novamente." } };
  }
  return Promise.reject(error);
});

export function formatApiError(detail) {
  if (detail == null) return "Erro inesperado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
